import { Injectable } from '@angular/core';
import { LogLevel } from '../../../model/log';
import { IEnvironmentConfig } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EnvService {
    public config: IEnvironmentConfig = {
        version: '',
        stationId: '',
        websocket: {
            url: 'ws://127.0.0.1:8080/api'
        },
        keycloak: {
            url: 'https://keycloak.adbsg.com/auth',
            realm: 'AiPRON',
            clientId: 'mop',
            'ssl-required': 'external',
            'public-client': true
        },
        log: {
            logLevel: LogLevel.Info,
            logToConsole: true
        },
        errorLog: {
            logErorrsToConsole: true
        },
        dateFormats: {
            date: 'dd-MM-yyyy',
            dateTime: 'dd-MM-yyyy HH:mm'
        },
        supportedBrowsers: {
            Chrome: {
                minVersion: 78
            },
            Firefox: {
                minVersion: 69
            },
            'MS-Edge': {
                minVersion: 17
            },
            Safari: {
                minVersion: 10
            }
        },
        docking: {
            pinCodeSuccessTimeout: 500
        },
        autoLogout: {
            enabled: true,
            threshold: 5
        },
        camera: {
            show: false
        },
        flights: {
            show: false
        },
        devEnv: true,
        skipPin: true,
        debounceTime: 250
    };
}
